// extracted by mini-css-extract-plugin
export default {"wrapper":"mD-z","viewport":"nD-z","container":"oD-z","slide":"pD-z"};